import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Typography } from '@mui/material';

import SummaryPage from './Dashboard/pages/SummaryPage';
import TransactionsPage from './Dashboard/pages/TransactionsPage';
import PaymentsPage from './Dashboard/pages/PaymentsPage';
import ReceivePage from './Dashboard/pages/ReceivePage';
import RegistrationBeneficiariesPage from './Dashboard/pages/RegistrationBeneficiariesPage';
import BankingOnboarding from './Onboarding';
import BankingAccountRegisterPage from './AccountRegister';
import BankingAccountDashboardPage from './Dashboard';

const BankingRoutes = () => {
  return (
    <Routes>
      <Route index element={<BankingOnboarding />} />
      <Route path="form" element={<BankingAccountRegisterPage />} />
      <Route path="dashboard" element={<BankingAccountDashboardPage />}>
        <Route index element={<Navigate to="summary" replace />} />
        <Route path="summary" element={<SummaryPage />} />
        <Route path="balance" element={<TransactionsPage />} />
        <Route path="pay" element={<PaymentsPage />} />
        <Route path="receive" element={<ReceivePage />} />
        <Route path="open-banking" element={<Typography>Open Banking Placeholder</Typography>} />
        <Route path="registration-beneficiaries" element={<RegistrationBeneficiariesPage />} />
      </Route>
    </Routes>
  );
};

export default BankingRoutes;
